exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading[data-v-97699af0]{color:#c26f02;border-bottom:0 solid #c26f02!important}.panel-heading h4[data-v-97699af0]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-97699af0]{overflow-x:hidden!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-97699af0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/makeNewOrder.vue
// module id = 841
// module chunks = 0